"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
var ExerciseCardWrapper = function ExerciseCardWrapper(Component) {
  var _class, _class2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _this.setCurrentCardId = function () {
        if (_this.props.inView && _state.ExerciseUI.currentCardId !== _this.props.card.id) {
          _state.ExerciseUI.set('currentCardId', _this.props.card.id);
        }
      };
      if (!_state.ExerciseUI.exercises[_this.props.card.id]) {
        _state.ExerciseUI.assignExerciseToCard(_this.props.card.id, _state.DeckUI.deck.exercises.find(function (item) {
          return item.id === _this.props.card.exerciseId;
        }));
      }
      if ((0, _utils.isPresent)(_this.exercise) && (0, _utils.isPresent)(_this.exercise.state)) {
        _this.exercise.state.reset();
      }
      _this.setCurrentCardId();
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        var _this2 = this;
        if (!_state.ExerciseUI.exercises[this.props.card.id]) {
          _state.ExerciseUI.assignExerciseToCard(this.props.card.id, _state.DeckUI.deck.exercises.find(function (item) {
            return item.id === _this2.props.card.exerciseId;
          }));
        }
        this.setCurrentCardId();
      }
    }, {
      key: "exercise",
      get: function get() {
        return _state.ExerciseUI.exercises[this.props.card.id];
      }
    }, {
      key: "answerFeedback",
      get: function get() {
        var _this$exercise,
          _this$exercise2,
          _this3 = this;
        if (!this.props.cardState.revealed || ((_this$exercise = this.exercise) === null || _this$exercise === void 0 || (_this$exercise = _this$exercise.exerciseType) === null || _this$exercise === void 0 ? void 0 : _this$exercise.slug) === 'multipleChoice') return [];
        return (((_this$exercise2 = this.exercise) === null || _this$exercise2 === void 0 ? void 0 : _this$exercise2.exerciseEntries) || []).map(function (entry) {
          return {
            id: entry.id,
            correct: entry.state.correct,
            userAnswer: _this3.userAnswer(entry)
          };
        });
      }
    }, {
      key: "userAnswer",
      value: function userAnswer(entry) {
        var _this$exercise3, _state$assignedExerci, _entry$multipleChoice, _entry$mediaOptions, _entry$sentence2;
        var state = entry.state;
        if (state.blankValueFilledIn) return null;
        if (((_this$exercise3 = this.exercise) === null || _this$exercise3 === void 0 || (_this$exercise3 = _this$exercise3.exerciseType) === null || _this$exercise3 === void 0 ? void 0 : _this$exercise3.slug) === 'wordEnter') {
          var _entry$sentence;
          return (0, _utils.formatBlankAnswer)((_entry$sentence = entry.sentence) === null || _entry$sentence === void 0 ? void 0 : _entry$sentence.wordAssociations, function (association) {
            var _association$state, _association$state2;
            return association.selected && !((_association$state = association.state) !== null && _association$state !== void 0 && _association$state.blankValueFilledIn) ? (_association$state2 = association.state) === null || _association$state2 === void 0 ? void 0 : _association$state2.submittedValue : '';
          });
        }
        if ((_state$assignedExerci = state.assignedExerciseEntry) !== null && _state$assignedExerci !== void 0 && _state$assignedExerci.id) return state.assignedExerciseEntry.prompt;
        if ((_entry$multipleChoice = entry.multipleChoiceOptions) !== null && _entry$multipleChoice !== void 0 && _entry$multipleChoice.length && state.submittedValue) {
          var selectedIds = String(state.submittedValue).split(',');
          return entry.multipleChoiceOptions.filter(function (option) {
            return selectedIds.includes(option.id);
          }).map(function (option) {
            return option.targetText;
          }).join(', ');
        }
        if ((_entry$mediaOptions = entry.mediaOptions) !== null && _entry$mediaOptions !== void 0 && _entry$mediaOptions.length && state.submittedValue) {
          var _selectedIds = String(state.submittedValue).split(',');
          return entry.shuffledMediaOptions.map(function (option, index) {
            return _selectedIds.includes(option.id) ? "Option ".concat(index + 1) : null;
          }).filter(Boolean).join(', ');
        }
        if (state.submittedValue !== null && state.submittedValue !== undefined) return state.submittedValue;
        return (((_entry$sentence2 = entry.sentence) === null || _entry$sentence2 === void 0 ? void 0 : _entry$sentence2.wordAssociations) || []).map(function (wordAssociation) {
          var wordState = wordAssociation.state;
          if (!wordState || wordState.blankValueFilledIn) return null;
          if (wordState.submittedWordAssociation) return wordState.submittedWordAssociation.targetText;
          if (wordState.submittedValue === true) return wordAssociation.targetText;
          if (wordState.submittedValue === false) return null;
          return wordState.submittedValue;
        }).filter(function (value) {
          return value !== undefined && value !== null && String(value).trim();
        }).join(' ');
      }
    }, {
      key: "icons",
      get: function get() {
        if (this.showWordCard) {
          return [];
        }
        var ary = [];
        if ((0, _utils.isPresent)(this.props.card.grammarTip)) {
          ary.push('grammarTip');
        }
        if (_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('reviewDetails');
        }
        if (!_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('toggleReview');
        }
        if (this.props.cardState.revealed && _state.DeckUI.showDeckGrammarIcon) {
          ary.push('deckGrammar');
        }
        if (_state.DeckUI.reviewDeck && (this.props.cardState.revealed || this.props.card.showNoteBeforeReveal)) {
          ary.push('cardNote');
        }
        return ary;
      }
    }, {
      key: "showAnswerDisabled",
      get: function get() {
        var _this$exercise4;
        if (((_this$exercise4 = this.exercise) === null || _this$exercise4 === void 0 || (_this$exercise4 = _this$exercise4.exerciseType) === null || _this$exercise4 === void 0 ? void 0 : _this$exercise4.slug) === 'reorder') {
          return !this.exercise.allSentenceExerciseEntriesHaveValues;
        }
        return !this.props.inView;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          exercise: this.exercise,
          answerFeedback: this.answerFeedback,
          icons: this.icons,
          showAnswerDisabled: this.showAnswerDisabled
        }));
      }
    }]);
  }(_react["default"].Component), _applyDecoratedDescriptor(_class2.prototype, "exercise", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "exercise"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "answerFeedback", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "answerFeedback"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "icons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "icons"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showAnswerDisabled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showAnswerDisabled"), _class2.prototype), _class2)) || _class;
};
ExerciseCardWrapper.displayName = 'ExerciseCardWrapper';
var _default = exports["default"] = ExerciseCardWrapper;